module.exports = __webpack_public_path__ + "img/face_shape_female_heart.7177cc9b.png";